import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect } from 'react-router-dom';

import { InputGroup, InputGroupAddon, Input } from 'reactstrap';
import axios from 'axios';
import {Progress} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from './Navbar'

class Dashboard extends Component {
    files = [];

    constructor(props) {
        super(props) 
        this.state = {
            toDashboard: false,
            selectedFile: null,
            username: '',
            email:'',
            id: '',
            note: '',
            selectedFile: null,
            editorsm: [],
            clientuser: '',
            files: [],
            imagesPreviewUrls: [],
            loaded:0,
            totalcount: '',
            totalprice:'',
            array:[]
        }
        this._handleImageChange = this._handleImageChange.bind(this)
        this.onClickHandler = this.onClickHandler.bind(this)
        this.onChange = this.onChange.bind(this)
        this._handleImageRemove = this._handleImageRemove.bind(this)
        
    } 
    
   

   


    _handleImageRemove = event =>{
      event.preventDefault();
      console.log('clicked')
    }
    



      onChange=(event)=>{
        this.setState({ [event.target.name]: event.target.value })
      }


    _handleImageChange = event =>{
        event.preventDefault();

        // FileList to Array
        let files = Array.from(event.target.files);
        

        // File Reader for Each file and and update state arrays
        files.forEach((file, i) => {
            let reader = new FileReader();

            reader.onloadend = () => {
                this.setState(prevState => ({
                    files: [...prevState.files, file],
                    imagesPreviewUrls: [...prevState.imagesPreviewUrls, reader.result]
                }));
            }
            reader.readAsDataURL(file);       
        });
        //console.log(this.files.length + 'forr');
    
        this.setState({ files: this.files })
        this.setState({selectedFile: event.target.files})
        this.setState({email: this.state.email})
        this.setState({note: this.state.note})
        this.setState({id: this.state.id})
    }


    onClickHandler = (event) => {
        event.preventDefault();
        const data = new FormData()
        data.append('id', this.state.id)
        data.append('note', this.state.note)
          data.append('email', this.state.email)
        for(var x = 0; x<this.state.selectedFile.length; x++) {
            data.append('files', this.state.selectedFile[x])
            console.log(this.files.length + 'forr12');
        }
       

       

  
           
        console.log(JSON.stringify(data))
        axios.post("https://apis.pixelbyhand.com/images/api", data, { 

            onUploadProgress: ProgressEvent => {
                this.setState({
                  loaded: (ProgressEvent.loaded / ProgressEvent.total*100),
              })
            }

         
})

.then(res => { 
  toast.success('upload success')
  setTimeout(() => {
   this.setState(() => ({
       toDashboard: true
     }))
  }, 7000);
})
.catch(err => { 
    toast.error('upload fail')
})

    }



    componentDidMount() {
    const min = 1;
    const max = 10000;
    const rand = Math.floor(Math.random()*(max-min+1)+min);
    const id = this.setState({id: this.state.id + rand})
    console.log(id) 
  }

    render() {

      let  newdemo = 1;

        if (this.state.toDashboard === true) {
            return  <Redirect
            to={{
              pathname: `/trial/signup`,
              state: { id: this.state.id },
            }}
          />
          }

          const totalcount = this.state.files.map(files=> {
          return <p>{files.length}</p>
              }
          )

        
          
          //totalcount.length; 
           console.log(totalcount.length + 'asdsd')

           const totalprice = totalcount.length *this.state.pricing ;
           console.log(totalprice)


          const editorsm = this.state.editorsm.map(editors => {
            return (
                
                 <option value={editors.id} key={editors.id}>{editors.firstname} {editors.lastname} </option>
            )
          })
          console.log(editorsm)



        let {imagesPreviewUrls} = this.state;
        
        return (

          <div className="">
           <Navbar/>
            
            <div className="usertag">
                <h1> SEND YOUR SAMPLE IMAGES TO EDIT FREE OF CHARGE </h1> 
            
                            </div>


         
            

          <form onSubmit={this.onClickHandler} className="uploadform">


                <div className="form-group multi-preview">
                {imagesPreviewUrls.map((imagePreviewUrl,  index, id) =>{
                    return ( 
                      <div className="imageFrmaes">
                         <p>click image to remove</p>
                      <img key={index} id={newdemo++}   src={imagePreviewUrl} 
                        onClick={(e, id) => {
                          var array = [...imagesPreviewUrls]
                           var id = imagePreviewUrl.indexOf(e.target.id)
                           var newId = e.target.id-1
                           console.log(e.target.id + "one")
                           console.log(newId + "two")
                           if (id !== -1) {
                                 
                            array.splice(newId, 1)
                            this.setState({imagesPreviewUrls: array})
                            console.log(imagesPreviewUrls)
                            
                         }
                         
                          
                }}
                      />
                     
              </div>
                    )
                  })}
                </div>

                <div className="form-group newinput"> 
                <label className="btn btn-default btn-sm z-depth-0 mr-0 pl-2 pr-2 custom-file-upload waves-effect waves-light" htmlFor="file">
                    <i className="fas fa-image fa-fw" aria-hidden="true"></i>
                    <input className="form-control  newin" required type="file" name="files" onChange={this._handleImageChange} multiple/>
                </label>
                </div>

                <div className="emailinput col-md-12">
               <label hidden htmlFor="id">ID</label>
                    <input
                      type="id"
                      type="hidden"
                      name="id"
                      required
                      
                      value={this.state.id}
                      
                    />
                  </div>

              

               <div className="emailinput col-md-12">
               <label  htmlFor="email">WHAT IS YOUR BUSINESS E-MAIL?</label>
                    <input
                      type="email"
                      required
                      name="email"
                      required
                      value={this.state.email}
                      onChange={this.onChange}
                    />
                  </div>
                  
                  
                  <div className="note col-md-12">
                  <label  htmlFor="note">FEEL FREE TO ADD ANY INSTRUCTIONS YOU MAY HAVE</label>
                    <textarea
                      required
                      name="note" 
                      value={this.state.note}
                      onChange={this.onChange}
                    />
                  </div>




                

                <Progress max="100" color="success" value={this.state.loaded} >{Math.round(this.state.loaded,2) }%</Progress>
               <div className="form-group"> <ToastContainer /></div>

               <div className="form-group not-wide"> 
                  <input type="submit" className="btn btn-danger btn-block button2" value="Upload Images" />
               </div> 


            </form>
            </div>
        )
    }
}




export default Dashboard;










